<template>
  <el-card class="box-card">
    <div slot="header" class="box-head clearfix">
      <span class="card-head">Instagram Insights</span>
      <span class="pull-right">
        <el-select v-model="instagramPage" size="mini">
          <el-option
            v-for="page in instagramPages"
            :key="page.id"
            :label="page.handle"
            :value="page.id"
          />
        </el-select>
      </span>
      <span class="pull-right">
        <el-radio-group v-model="period" size="mini">
          <el-radio-button label="day" />
          <el-radio-button label="week" />
          <el-radio-button label="month" />
        </el-radio-group>
      </span>
    </div>
    <div class="card-content">
      <div v-if="isLoading" class="insights-container">
        <loader message="Loading Insights" shadow="none" />
      </div>
      <div v-else-if="hasData" class="insights-container">
        <InsightsOverviewItem
          v-for="(value, key) in overviewData"
          class="insight-item"
          :data="value"
          :period="period"
          :key="key"
          @onNavigate="handleItemNavigate(key)"
        />
      </div>
      <div v-else class="placeholder">
        <content-placeholder
          :count="1"
          :text-only="true"
          :text-value="instagramPage ? 'No data' : 'No page connected'"
        />
      </div>
    </div>
  </el-card>
</template>

<script>
import Loader from '@/components/common/Loader';
import ContentPlaceholder from '@/components/common/ContentPlaceholder';
import InsightsOverviewItem from './InsightsOverviewItem';

export default {
  name: 'InsightsOverview',

  props: {
    overviewData: {
      type: Array,
      default: () => [],
    },
    instagramPages: {
      type: Array,
      default: () => [],
    },
    selectedPage: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    period: 'day',
    metricRoutes: {
      profile_views: 'profile_views',
      follower_count: 'follower_count',
      reach: 'reach',
      impressions: 'impressions',
    },
  }),

  computed: {
    instagramPage: {
      get() {
        return this.selectedPage;
      },
      set(value) {
        this.$emit('onSelectedPageChange', value);
      },
    },
    hasData() {
      return Array.isArray(this.overviewData) && this.overviewData.length > 0;
    },
  },

  methods: {
    handleItemNavigate(key) {
      this.$router.push(`social/instagram/${this.metricRoutes[key]}`);
    },
  },

  watch: {
    period(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('onInstagramPeriodChanged', newVal);
      }
    },
  },

  components: {
    InsightsOverviewItem,
    Loader,
    ContentPlaceholder,
  },
};
</script>

<style lang="scss" scoped>
$my-text-color: #676a6c;

.insights-container {
  padding: 0;
  margin: -10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.insight-item {
  width: 300px;
  height: 200px;
  margin: 10px;
}

.card-head {
  font-size: 1.3em;
}

.clearfix:after {
  clear: both;
}

.box-card {
  color: $my-text-color;
}

.box-head {
  height: 1.5em;
}

.card-content {
  min-height: 350px;
  margin: 0px;
}

.posts-placeholder {
  text-align: center;
  color: lighten($my-text-color, 25);
  font-size: 1.2em;
}
</style>



// WEBPACK FOOTER //
// InsightsOverview.vue?5092346e